export const BACKDROP_IDENTIFIER = 'kmcc-backdrop';
export const CLASSES = {
    VISIBLE: 'kmcc-backdrop--visible',
};



// WEBPACK FOOTER //
// ./vendor/kunstmaan/cookie-bundle/Resources/ui/js/config/backdrop.config.js